module.exports = __webpack_public_path__ + "img/modal3.1cf976c5.png";